// Typelizer digest 4cd442289f60c52e86ddad64829f28c7
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /passkeys/session */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/passkeys/session', {}, options),
    method: 'post',
  }),
}
